module.exports = __webpack_public_path__ + "img/layout_bottom_1.bb7efb2f.jpg";